import PropTypes from 'prop-types';
import React from 'react';
import CommentFormToolTip from '../CommentFormToolTip/CommentFormToolTip';

import './SubmitComment.scss';

export default class SubmitComment extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            showTipField: true,
            topPosition: '55px',
        };
    }

    static propTypes = {
        /**
         * type of policy
         */
        type: PropTypes.string,
        /**
         * title of the comment form
         */
        title: PropTypes.string.isRequired,
        /**
         * user entered tip
         */
        tip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /**
         * user entered comment
         */
        comment: PropTypes.string,
        /**
         * on tip input change function
         */
        onTipChange: PropTypes.func,
        /**
         * on comment input change function
         */
        onCommentChange: PropTypes.func.isRequired,
        /**
         * submit function
         */
        onSubmit: PropTypes.func.isRequired,
        /**
         * function to clear form
         */
        clearForm: PropTypes.func,
        /**
         * tip input type
         */
        tipInputType: PropTypes.oneOf(['dropdown', 'inputBox']),
    };

    static defaultProps = {
        type: 'others',
        onTipChange: () => {},
        tipInputType: 'inputBox',
        tip: '',
        comment: '',
        clearForm: () => {},
    };

    onTipOpen = () => {
        this.setState({
            showForm: true,
            showTipField: true,
            topPosition: '52px',
        });
    };

    onCommentOpen = () => {
        this.setState({
            showForm: true,
            showTipField: false,
            topPosition: '100px',
        });
    };

    onTipMobileOpen = () => {
        this.setState({
            showForm: true,
            showTipField: true,
            topPosition: '37px',
        });
    };

    onCommentMobileOpen = () => {
        this.setState({
            showForm: true,
            showTipField: false,
            topPosition: '72px',
        });
    };

    closeForm = () => {
        this.setState({ showForm: false });
    };

    onSubmit = () => {
        this.setState({ showForm: false });
        this.props.onSubmit();
    };

    render() {
        let style = {};
        if (this.state.topPosition) {
            style.top = this.state.topPosition;
        }

        return (
            <div className="component-Employer-Benefits-SubmitComment">
                <div className="large d-none d-md-block">
                    <div className="gray-row p-3 field-description">
                        {this.props.type !== 'others' ? (
                            <span className="tip" onClick={this.onTipOpen}>
                                Submit a Tip / Correction
                            </span>
                        ) : (
                            <span
                                className="comment"
                                onClick={this.onCommentOpen}
                            >
                                Add a Comment
                            </span>
                        )}
                    </div>

                    <div className="p-2 field-description">
                        {this.props.type !== 'others' ? (
                            <span
                                className="comment"
                                onClick={this.onCommentOpen}
                            >
                                Add a Comment
                            </span>
                        ) : null}
                    </div>
                </div>

                <div className="small d-block d-md-none">
                    <div className="gray-row p-2 text-left">
                        <div
                            className="field-description p-1 pl-2 mobile-tip"
                            onClick={this.onTipMobileOpen}
                        >
                            Submit a Tip / Correction
                        </div>
                        <div
                            className="field-description p-1 pl-2 mobile-comment"
                            onClick={this.onCommentMobileOpen}
                        >
                            Add a Comment
                        </div>
                    </div>
                </div>

                <div className="comment-form" style={style}>
                    <CommentFormToolTip
                        tipInputType={this.props.tipInputType}
                        showForm={this.state.showForm}
                        showTipField={this.state.showTipField}
                        title={this.props.title}
                        tip={this.props.tip}
                        comment={this.props.comment}
                        onTipChange={this.props.onTipChange}
                        onCommentChange={this.props.onCommentChange}
                        closeForm={this.closeForm}
                        onSubmit={this.onSubmit}
                    />
                </div>
            </div>
        );
    }
}
